import { useRecordContext } from "ra-core";
import type { Deal } from "../types";
import { ReferenceField, TextField } from "@/components/admin";
import { CompanyAvatar } from "../companies/CompanyAvatar";
import { NoCompanyAvatar, NoCompanyLabel } from "../deals/NoCompany";

export const DealOption = () => {
  const record: Deal | undefined = useRecordContext();
  if (!record) return null;
  return (
    <div className="flex flex-row gap-4 items-center justify-start whitespace-normal text-left">
      <ReferenceField
        source="company_id"
        reference="companies"
        link={false}
        empty={<NoCompanyAvatar size={40} />}
      >
        <CompanyAvatar height={40} width={40} />
      </ReferenceField>
      <div className="flex flex-col items-start gap-1">
        <span>{record.name}</span>
        <span className="text-xs text-muted-foreground">
          <ReferenceField
            source="company_id"
            reference="companies"
            link={false}
            empty={<NoCompanyLabel />}
          >
            <TextField source="name" />
          </ReferenceField>
        </span>
      </div>
    </div>
  );
};
